import CardForm from 'components/creditCard/Form/components/CardForm/styled';

export default CardForm;
